import React, { memo } from 'react';
import classNames from 'classnames';
import styles from 'assets/css/CourseComponent.module.css';
import buttonStyles from 'assets/css/Button.module.css';

import CardLink, { CardLinkIconWrap } from 'Components/Card/CardLink';
import ProgressBar from 'Components/ProgressBar';
import { RenderRawHTML } from '@ace/react-utilities';

import { IconAngleRight, IconPhone, IconCheckmarkCircle, IconSlashCircle, IconLock, IconCart }  from '@ace/react-icons';

const CoursePartials = {
    PassedStatus: memo(() => (<span className={`${styles.status} ${styles.statusPassed}`}><IconCheckmarkCircle /> Passed!</span>)),
    NotPassedStatus: memo(() => (<span className={`${styles.status} ${styles.statusFailed}`}><IconSlashCircle /> Did not pass</span>)),
    Upgrade: memo(({upgradeText, upgradeIcon}) => {
        const upgradeIcons = {
            IconPhone: IconPhone,
            IconCart: IconCart
        };
        const UpgradeIcon = upgradeIcons[upgradeIcon ?? 'IconPhone'];
        return (upgradeText ?
            <p className={styles.upgradeRequired}>
                {UpgradeIcon && <UpgradeIcon fill="currentColor" />}
                <span>
                    {upgradeText}
                </span>
            </p>
            : false)}
    ),
    Progress: (course) => {
        const progressBarClasses = classNames({ "failed": courseHelpers.hasFailed(course) });
        const Status = () => (course.Passed ? <CoursePartials.PassedStatus /> : <CoursePartials.NotPassedStatus />);

        return (
            <div className={styles.progressWrap}>
                <div className={styles.progressTextWrap}>
                    <p className={styles.progressText}>
                        {course.PercentageComplete}% Complete
                    </p>
                    {course.Taken && <Status />}
                </div>
                <div>
                    <ProgressBar className={progressBarClasses} percentage={course.PercentageComplete} />
                </div>
            </div>
        );
    },
    Welcome: ({welcomeMessageTitle: copy}) => (copy && copy.length ? <p className={styles.welcome}>{copy}</p> : false),
    BodyCopy: ({bodyStateCopy: copy, classes = styles.welcome}) => (copy && copy.length ? <>{RenderRawHTML(copy, { usePTag: true, className: classes })}</> : false),
    CardLink: (course) => 
        (<CardLink
            linkText={course.ActionLink.CardLinkText}
            linkIcon={<IconAngleRight />}
            linkUrl={course.ActionLink.CardLinkUri}
            target="_blank"
            className={`${styles.courseBtn} ${courseHelpers.cardLinkBtnClass(course)}`} />),
    LockedBtn: memo(() => (<span className={`${buttonStyles.stroke} ${buttonStyles.strokeDisabled}`} style={{ marginTop: '1rem', backgroundColor: '#eff3f4' }}><CardLinkIconWrap><IconLock /></CardLinkIconWrap> Locked</span>))
}

export const courseHelpers = {
    cardLinkBtnClass: (course) => course.HasCourse
        ? buttonStyles.stroke
        : buttonStyles.purchase,
    hasFailed: (course) => course.Taken && !course.Passed,
};

export default CoursePartials;